'use client'

import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { LoadingIcon } from "@/(front-desk)/utils/patterns"
import { reportError } from "@/(front-desk)/utils/functions"
import LanguageBtn from "@/(front-desk)/components/LanguageBtn"
import Transition from "@/(front-desk)/components/Transition"
import Marquee from "@/(front-desk)/components/Marquee"
import Markdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import axios from "axios"

export default function informationTransportation() {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.global).language
    const infoTransportation = useSelector((state) => state.CMS).infoTransportation[language]

    useEffect(() => {
        if (language && !infoTransportation) {
            axios.get(`/api/v1/cms/${language}/transportation-info`)
            .then((res) => {
                // console.log(res.config?.url, res.data.body)
                dispatch(handleCMS.actions.setInfoTransportation({
                    language: language,
                    data: res.data.body
                }))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
            })
        }
    }, [language])

    return (
        <>
        <title>交通資訊 - 放視大賞</title>
        <main className="information-transportation flex flex-col justify-between">
            <div className="page-banner">
                <div className="page-banner-content flex flex-wrap gap-4 justify-between items-end">
                    <div className="">
                        <h1 className="title">Transportation</h1>
                        <h2 className="sub-title">交通資訊</h2>
                    </div>
                    <LanguageBtn />
                </div>
            </div>
            <Transition transitionKey={[infoTransportation, language]}>
                { !infoTransportation
                    ?
                    <div className="flex-center">
                        <LoadingIcon />
                    </div>
                    :
                    <div className="transportation-content pt-[2.5rem] text-white mb-[10rem]">
                        <div className="flex justify-center mb-[1.5rem] h-[30rem]">
                            <iframe
                                src={infoTransportation.google_map_source}
                                className="absolute w-screen h-[30rem]"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                        <div id="main" className="items w-full">
                            { infoTransportation.items.map((item) => (
                                // console.log(item.title, JSON.stringify(item.content_md)),
                                <div
                                    key={`infoTransportation-${item.id}`}
                                    className="item flex gap-2 border-b border-black-700 py-[2.5rem]"
                                >
                                    <div className="text-[1.5rem] text-main font-semibold w-[12.5rem] shrink-0">
                                        {item.title}
                                    </div>
                                    <div id="information-transportation">
                                        <Markdown rehypePlugins={[rehypeRaw]}>
                                            {item.content_md
                                                .replace(/\r\n/g,
                                                    match => '<br>'+ match.repeat(2)
                                                )
                                                // .replace(/(\r\n){2,}/g,
                                                //     match => '<br>'.repeat(match.length / 2) + match + '\r\n'
                                                // )
                                            }
                                        </Markdown>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </Transition>
            <Marquee />
        </main>
        </>
    )
}